import { formatNum, formatPercentNum, formatSmallValue, getSystemColor } from "@/pages/dashboard/utils/utils";
import * as echarts from 'echarts';
import { getSystemFlag } from "../../pages/overview/_config/system";
import { defaultPlatforms, platforms } from "../../pages/overview/_config/platforms";
import { thousandthFormat } from "@/pages/home/utils/common";
import { LIGHT_COLOR_ARR } from "../Chart/_config/constant";
import { OFFICIAL_WEBSITE } from "../../pages/overview/_config/constant";
import { IFormatPlatformList } from "./types";

/**
 * @description: 卡片位指标数值超过百万，需要增加单位M|B
 * @param {string|number} data
 * @return {string}
 */
const unitConversionMillion = (data: number): string => {
  if (data >= 1000000 && data < 1000000000) {
    return `${(Math.round(data / 10000) / 100).toFixed(2)  }M`;
  }
  return `${(Math.round(data / 10000000) / 100).toFixed(2)  }B`;
};


// 根据不同的数据类型返回不同的字符串
export const getFormateStr = (type: string, value: any, metrics_name: string, isUserType = false) => {
  const millionMetric = `units_number|new_users|active_users|aot|pcu|pay_amount|mtx_dlc_revenue|mtx_revenue|mtx_payers|paid_users|revenue|accumulated_revenue|avg_selling_price_asp|net_revenue|accumulated_revenue|asp|refund_revenue`;
  // 指标数值超过百万显示单位M|B
  const isMillionMetrics = new RegExp(`^(${millionMetric})$`, 'g').test(metrics_name) && value >= 1000000;
  switch (type) {
    case 'int':
      if (isMillionMetrics) {
        return unitConversionMillion(value);
      }
      if (metrics_name === 'arpu') return value < 1 && value > 0 ? formatSmallValue(value,'decimals',2) : formatNum(value, false, isUserType);
      return formatNum(value, false, isUserType);
    case 'decimals':
      if (isMillionMetrics) {
        return unitConversionMillion(value);
      }
      if (metrics_name === 'arpu') return value < 1 && value > 0 ? formatSmallValue(value,'decimals',2) : formatNum(value, false, isUserType);
      return formatNum(value, false, isUserType);
    case 'percent':
      if((metrics_name === 'accumulated_refund_rate' || metrics_name === 'lifetime_refund_rate') && value < 0) return `-${  formatPercentNum(parseFloat(value), 2)}`;
      return formatPercentNum(parseFloat(value), 2);
  }
};

// 根据不同的数据类型返回不同的字符串
export const getDecimalFormateStr = (type: string, value: any, metrics_name: string, decimal = 2) => {
  const millionMetric = `units_number|new_users|active_users|aot|pcu|pay_amount|mtx_dlc_revenue|mtx_revenue|mtx_payers|paid_users|gross_full_game_units
  revenue|accumulated_revenue|avg_selling_price_asp|net_revenue|accumulated_revenue|asp|refund_revenue|DAU|MAU|Revenue|New|lifetime_net_revenue|lifetime_net_units|gross_revenue|lifetime_revenue_after_refund|lifetime_gross_revenue`;
  // 指标数值超过百万显示单位M|B
  const isMillionMetrics = new RegExp(`^(${millionMetric})$`, 'g').test(metrics_name) && value >= 1000000;
  switch (type) {
    case 'int':
      if (isMillionMetrics) {
        return unitConversionMillion(value);
      }
      if (metrics_name === 'arpu') return value < 1 && value > 0 ? formatSmallValue(value,'decimals',2) : thousandthFormat(value, decimal, true, '-');
      return thousandthFormat(value, 0, true, '-');
    case 'decimals':
      if (isMillionMetrics) {
        return unitConversionMillion(value);
      }
      if (metrics_name === 'arpu') return value < 1 && value > 0 ? formatSmallValue(value,'decimals',2) : thousandthFormat(value, decimal, true, '-');
      return thousandthFormat(value, decimal, true, '-');
    case 'percent':
      return formatPercentNum(parseFloat(value), decimal);
  }
};

export const formatSeries = (trendData: string[][], dateDimension: string, formatMessage: (arg0: { id: string; }) => any) => {
  const seriesNameFirst = dateDimension === 'DAY' ? 'card_today' : dateDimension === 'WEEK' ? 'card_week' : 'card_month';
  const seriesNameTwo = dateDimension === 'DAY' ? 'sdlw' : dateDimension === 'WEEK' ? 'swlm' : 'smly';
  return trendData?.map((t: string[], i: number) => ({
    name: i === 0 ? formatMessage({ id: seriesNameFirst }) : formatMessage({ id: seriesNameTwo }),
    type: 'line',
    showSymbol: t?.length === 1 || t?.filter((e) => e)?.length === 1, // 只有一个点的时候需要显示圆点
    symbol: 'circle',
    z: i === 0 ? 2 : 1,
    lineStyle: {
      type: i === 0 ? 'solid' : 'dotted'
    },
    areaStyle: {
      opacity: 0.25,
      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        {
          offset: 0,
          color: i === 0 ? '#5086F3' : '#69D19C'

            
        },
        {
          offset: 1,
          color: '#FFF'
        },
      ])
    },
    emphasis: {
      focus: 'series'
    },
    data: t,
  }));
};

export const formatSeriesInflextion = (trendData: string[][], dateDimension: string, formatMessage: (arg0: { id: string; })=> any,isContrastSDLW:boolean,) => trendData?.map((t: string[], i: number) => ({
  name: i === 0 ? `${formatMessage({ id: 'common_today' })}` : i === 1 ? `${formatMessage({ id: 'common_yesterday' })}` : isContrastSDLW?`${formatMessage({ id: 'common_sdlw'})}`:`${formatMessage({ id: 'contrast day'})}`,
  type: 'line',
  showSymbol: t?.length === 1 || t?.filter((e) => e)?.length === 1, // 只有一个点的时候需要显示圆点
  symbol: 'circle',
  z: i === 0 ? 2 : 1,
  lineStyle: {
    type: i === 0 ? 'solid' : 'dotted'
  },
  areaStyle: {
    opacity: 0.25,
    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
      {
        offset: 0,
        color: i === 0 ? '#5086F3' : i === 1 ? '#69D19C' : '#6E7794',
      },
      {
        offset: 1,
        color: '#FFF'
      },
    ])
  },
  emphasis: {
    focus: 'series'
  },
  data: t,
}));

export const formatPlatformList = (
  disableProgressList: any[],
  platformDataList: any[],
  selectedIdList: any[],
  gameCode: string
): IFormatPlatformList => {
  // 无数据展示默认五个平台配置
  if (!platformDataList?.length) {
    return {
      progressList: disableProgressList
    };
  }

  const newPlatformDataList = platformDataList?.length > 5 ? platformDataList?.slice(0, 5) : (platformDataList || []);
  const newProgressList: any = [];
  newPlatformDataList?.map((platform: any, index) => {
    const name = platform?.full_name?.trim()?.toLowerCase();
    let systemName = name;
    if (OFFICIAL_WEBSITE.includes(name) && gameCode) {
      systemName = `${gameCode?.toLowerCase()?.trim()}_${name}`;
    }
    const icon = getSystemFlag(name) || defaultPlatforms?.icon;
    const dataItem = platforms.find((item: any) => (item?.title?.trim()?.toLowerCase() === systemName || item?.subtitle?.find(w => name?.startsWith(w))));
    const disableIcon = dataItem ? dataItem?.disableIcon : getSystemFlag(name) || defaultPlatforms?.icon;
    const platformIsSelected =
      selectedIdList?.includes("255") ?
        true : !!selectedIdList?.includes(platform?.name);

    const num = platform?.value === '' ? '-' : platformIsSelected ? platform?.value : '0';
    if (num !== '0' && num !== '-') {
      newProgressList.push({
        isSelected: platformIsSelected,
        hasData: true,
        icon,
        isOpacity: false,
        disableIcon,
        title: platform?.full_name,
        isBlackImg: dataItem?.isBlack,
        isDefault: icon === defaultPlatforms?.icon,
        // 进度条样式补充
        color: getSystemColor(name) || LIGHT_COLOR_ARR[index],
        num,
        share: platform?.share_of_all,
        name: platform?.name
      });
    }
  });

  return {
    progressList: newProgressList
  };
};